import React from 'react';
import { Grid } from '@mui/material';

const CustomGrid: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Grid container>
      <Grid
        item
        style={{
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        {children}
      </Grid>
    </Grid>
  );
};

export default CustomGrid;
